import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import Aguardando from '../common/template/aguardando';
import ProducaoCargaForm from './producaoCargaForm';

import {
	setCarga, limparCarga, buscarCarga, getHistorico, iniciarProducaoCarga,
	cancelarInicioProducaoCarga, finalizarProducaoCarga,
	reabrirProducaoCarga, salvarLotes
} from './producaoCargaActions';

class ProducaoCarga extends Component {

	constructor(props) {
		super(props);
		this.state = { codigo: '' };
		this.inputCodigo = React.createRef();
		this.leituraEmAndamento = false;
	}

	componentDidMount() {
		this.focarLeitor();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.carga && !this.props.carga) {
			this.focarLeitor();
		}
	}

	focarLeitor() {
		setTimeout(() => {
			if (this.inputCodigo.current) this.inputCodigo.current.focus();
		}, 100);
	}

	buscar(event) {
		event.preventDefault();
		this.abrirCarga(this.state.codigo);
	}

	abrirCarga(codigo) {
		if (this.props.aguardando || this.leituraEmAndamento) return;

		this.leituraEmAndamento = true;

		this.props.buscarCarga(codigo).then(sucesso => {
			if (sucesso) this.setState({ codigo: '' });
		}).finally(() => {
			this.leituraEmAndamento = false;
		});
	}

	alterarCodigo(codigo) {
		this.setState({ codigo }, () => {
			if (/^\d{10}$/.test(codigo)) {
				this.abrirCarga(codigo);
			}
		});
	}

	renderLeitor() {
		return (
			<ContentCard>
				<ContentCardBody>
					<form onSubmit={event => this.buscar(event)} style={{ maxWidth: 600, margin: '40px auto', textAlign: 'center' }}>
						<i className='fas fa-barcode' style={{ fontSize: 54, marginBottom: 12 }}></i>
						<h3>Produção da Carga</h3>
						<p>Leia o código de barras da carga para iniciar ou continuar.</p>
						<input
							ref={this.inputCodigo}
							type='text'
							className='form-control form-control-lg'
							style={{ textAlign: 'center', fontSize: 24 }}
							placeholder='Aguardando leitura...'
							value={this.state.codigo}
							onChange={event => this.alterarCodigo(event.target.value)}
							autoComplete='off' />
						<small className='form-text text-muted'>
							A carga será aberta automaticamente após a leitura.
						</small>
					</form>
				</ContentCardBody>
			</ContentCard>
		);
	}

	render() {
		return (
			<Content>
				<Aguardando aguardando={this.props.aguardando} />
				{this.props.carga ? <ProducaoCargaForm {...this.props} /> : this.renderLeitor()}
			</Content>
		);
	}
}

const mapStateToProps = state => ({
	aguardando: state.producaoCarga.aguardando,
	salvando: state.producaoCarga.salvando,
	carga: state.producaoCarga.carga,
	historico: state.producaoCarga.historico,
	podeIniciar: state.auth.getPermissao('producao_carga', ['INCLUSAO']),
	podeAlterar: state.auth.getPermissao('producao_carga', ['ALTERACAO']),
	podeExcluir: state.auth.getPermissao('producao_carga', ['EXCLUSAO'])
});

const mapDispatchToProps = dispatch => bindActionCreators({
	setCarga, limparCarga, buscarCarga, getHistorico, iniciarProducaoCarga,
	cancelarInicioProducaoCarga, finalizarProducaoCarga,
	reabrirProducaoCarga, salvarLotes
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProducaoCarga);
